import Cookies from 'universal-cookie'
import { TIPO_ORIGEN } from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/consts'
import { OrganoDestinoFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/organoDestinoTypes'
import {
  ProcedimientoFormInitialvalues,
  ProcedimientoFormValues
} from 'src/components/views/EscritosLexnet/components/shared/types/procedimientoTypes'
import { LEXNET_COOKIE_NAME } from 'src/config'
import { CautelarOpciones, ResolucionOpciones, TipoResolucion } from 'src/enums/EscritosLegales'
import { FormField } from 'src/enums/Form'
import { LexnetCookieValue } from 'src/hooks/useCookie'
import {
  TipoCuantia,
  TipoEscrito,
  TipoMensaje,
  Materia,
  Entidad,
  OrganismoExtrajudicial
} from 'src/interfaces/Catalog'
import {
  TrasladoCopia,
  DocumentoPrincipalType,
  FileHashType,
  Interviniente
} from 'src/interfaces/EscritosLegales'
import { OrganoOrigenFormValues } from './organoOrigenTypes'

export type EscritosFormValues = {
  [FormField.CAUTELAR]: CautelarOpciones
  [FormField.DATOS_CAUSA_CON_DETENIDO]: boolean
  [FormField.DATOS_CAUSA_CON_PRESO]: boolean
  [FormField.DATOS_CAUTELARISIMA]: boolean
  [FormField.DATOS_CUANTIA_COMISION_IMPAGO_RECIBOS]: string
  [FormField.DATOS_CUANTIA_COSTAS]: string
  [FormField.DATOS_CUANTIA_INTERESES]: string
  [FormField.DATOS_CUANTIA_INTERESES_DEMORA]: string
  [FormField.DATOS_CUANTIA_INTERESES_REMUNERATORIOS]: string
  [FormField.DATOS_CUANTIA_PENALIZACION_RETRASO_PAGO]: string
  [FormField.DATOS_CUANTIA_PRINCIPAL]: string
  [FormField.DATOS_CUANTIA_RECONVENCION]: string
  [FormField.DATOS_DELITO]: Materia | null
  [FormField.DATOS_DEUDA_PARTIDO_JUDICIAL]: boolean
  [FormField.DATOS_FECHA]: Date | null
  [FormField.DATOS_FECHA_ACUERDO]: Date | null
  [FormField.DATOS_FUNDAMENTOS_DERECHO]: string
  [FormField.DATOS_HORA]: Date | null
  [FormField.DATOS_LOCALIDAD]: string
  [FormField.DATOS_MASC]: boolean
  [FormField.DATOS_MATERIA]: Materia | null
  [FormField.DATOS_MERCANTIL]: boolean
  [FormField.DATOS_MEDIDA_CAUTELAR_COETANEA]: boolean
  [FormField.DATOS_MEDIDA_CAUTELAR_PREVIA]: boolean
  [FormField.DATOS_NUMERO_EXPEDIENTE_ORIGEN]: string
  [FormField.DATOS_OBJETO_RECURSO]: string
  [FormField.DATOS_OBSERVACIONES]: string
  [FormField.DATOS_ORGANISMO]: string
  [FormField.DATOS_ORGANISMO_ORIGEN]: Entidad | string | null
  [FormField.DATOS_ORIGEN_DEUDA]: string
  [FormField.DATOS_PETICION]: string
  [FormField.DATOS_PETICION_COMPLEMENTARIA]: string
  [FormField.DATOS_RECLAMACION_COMUNIDAD]: boolean
  [FormField.DATOS_RECLAMACION_CONSUMIDOR]: boolean
  [FormField.DATOS_RECONVENCION]: string
  [FormField.DATOS_TIPO_CUANTIA]: TipoCuantia | null
  [FormField.DATOS_URGENTE]: boolean
  [FormField.DATOS_VIOLENCIA_GENERO]: boolean
  [FormField.DATOS_YEAR_EXPEDIENTE_ORIGEN]: string
  [FormField.DOCUMENTOS_ANEXOS]: []
  [FormField.DOCUMENTOS_ANEXOS_ARCHIVO]: FileHashType[]
  [FormField.DOCUMENTO_PRINCIPAL]: DocumentoPrincipalType[]
  [FormField.DOCUMENTO_PRINCIPAL_ARCHIVO]: FileHashType | null
  [FormField.ES_CORRECCION]: boolean
  [FormField.EXCESO_CABIDA]: boolean
  [FormField.FECHA_RESOLUCION]: Date | null
  [FormField.ID]: number
  [FormField.ID_MENSAJE_CORRECCION]: string
  [FormField.INTERVINIENTES]: Interviniente[] | null
  [FormField.INTERVINIENTES_FROM_LEXON_VALIDATED]: boolean
  [FormField.INTERVINIENTE_INFORMAR_FISCALIA]: boolean
  [FormField.NIG_1]: string
  [FormField.NIG_2]: string
  [FormField.NIG_3]: string
  [FormField.NIG_4]: string
  [FormField.NIG_5]: string
  [FormField.NIG_FORM_EXPEDIENTE]: string
  [FormField.NIG_FULL_NUMBER]: string
  [FormField.NUMERO_RESOLUCION]: string
  [FormField.ORGANO_DESTINO]: OrganoDestinoFormValues | null
  [FormField.ORGANO_DESTINO_DESCRIPCION]: string
  [FormField.ORGANO_DESTINO_DE_TITULO_JUDICIAL]: boolean | null
  [FormField.ORGANO_DESTINO_ENVIAR_JUZGADO_GUARDIA]: boolean
  [FormField.ORGANO_DESTINO_ORDEN_DESCRIPCION]: string
  [FormField.ORGANO_ORIGEN]: OrganoOrigenFormValues | null
  [FormField.ORGANO_ORIGEN_DESCRIPCION]: string
  [FormField.ORGANO_ORIGEN_ENVIAR_JUZGADO_GUARDIA]: boolean
  [FormField.ORGANO_ORIGEN_NUMERO_EXPEDIENTE]: string
  [FormField.ORGANO_ORIGEN_ORDEN_DESCRIPCION]: string
  [FormField.ORGANO_ORIGEN_ORGANISMO_ORIGEN]: OrganismoExtrajudicial | null
  [FormField.ORGANO_ORIGEN_TIPO_ORIGEN]: TIPO_ORIGEN | null
  [FormField.ORGANO_ORIGEN_YEAR_EXPEDIENTE]: string
  [FormField.PROCEDIMIENTO]: ProcedimientoFormValues | null
  [FormField.PROCEDIMIENTO_DESCRIPCION]: string
  [FormField.PROCEDIMIENTO_NUMERO_FORM]: string
  [FormField.PROCEDIMIENTO_NUMERO_PIEZA]: string
  [FormField.PROCEDIMIENTO_ORIGEN]: string
  [FormField.PROCEDIMIENTO_ORIGEN_REFERENCIA]: string
  [FormField.PROCEDIMIENTO_REFERENCIA]: string
  [FormField.PROCEDIMIENTO_YEAR_FORM]: string
  [FormField.REMITENTE_TITULAR]: string
  [FormField.RESOLUCION]: ResolucionOpciones
  [FormField.RESOLUCION_BIS]: boolean
  [FormField.TIPO]: TipoEscrito | null
  [FormField.TIPO_ESCRITO]: TipoMensaje | null
  [FormField.TIPO_RESOLUCION]: TipoResolucion | null
  [FormField.TRASLADO_COPIAS]: TrasladoCopia[]
  [FormField.TRASLADO_COPIA]: TrasladoCopia | null
  [FormField.YEAR_RESOLUCION]: string
}

const getRemitenteFromLexnetCookie = (): string => {
  const cookies = new Cookies()
  const cookieValue: LexnetCookieValue | undefined = cookies.get(LEXNET_COOKIE_NAME)
  if (cookieValue !== undefined) {
    const { userText } = cookieValue
    return userText
  }
  return ''
}

export const EscritoFormInitialValues: EscritosFormValues = {
  [FormField.ID]: 0,
  [FormField.DATOS_OBSERVACIONES]: '',
  [FormField.DATOS_ORIGEN_DEUDA]: '',
  [FormField.DATOS_FUNDAMENTOS_DERECHO]: '',
  [FormField.DATOS_RECLAMACION_CONSUMIDOR]: false,
  [FormField.DATOS_RECLAMACION_COMUNIDAD]: false,
  [FormField.DATOS_DEUDA_PARTIDO_JUDICIAL]: false,
  [FormField.DATOS_MASC]: true,
  [FormField.DATOS_PETICION]: '',
  [FormField.DATOS_PETICION_COMPLEMENTARIA]: '',
  [FormField.DATOS_TIPO_CUANTIA]: null,
  [FormField.DATOS_CUANTIA_RECONVENCION]: '',
  [FormField.DATOS_RECONVENCION]: 'No',
  [FormField.DATOS_URGENTE]: false,
  [FormField.DATOS_MATERIA]: null,
  [FormField.DATOS_MERCANTIL]: false,
  [FormField.DATOS_DELITO]: null,
  [FormField.DATOS_LOCALIDAD]: '',
  [FormField.DATOS_FECHA]: null,
  [FormField.DATOS_HORA]: null,
  [FormField.DATOS_MEDIDA_CAUTELAR_PREVIA]: false,
  [FormField.DATOS_MEDIDA_CAUTELAR_COETANEA]: false,
  [FormField.DATOS_CAUTELARISIMA]: false,
  [FormField.DATOS_CAUSA_CON_DETENIDO]: false,
  [FormField.DATOS_CAUSA_CON_PRESO]: false,
  [FormField.DATOS_VIOLENCIA_GENERO]: false,
  [FormField.DATOS_CUANTIA_PRINCIPAL]: '',
  [FormField.DATOS_CUANTIA_INTERESES]: '0',
  [FormField.DATOS_CUANTIA_COSTAS]: '0',
  [FormField.DATOS_CUANTIA_INTERESES_REMUNERATORIOS]: '',
  [FormField.DATOS_CUANTIA_INTERESES_DEMORA]: '',
  [FormField.DATOS_CUANTIA_COMISION_IMPAGO_RECIBOS]: '',
  [FormField.DATOS_CUANTIA_PENALIZACION_RETRASO_PAGO]: '',
  [FormField.DATOS_FECHA_ACUERDO]: null,
  [FormField.DATOS_OBJETO_RECURSO]: '',
  [FormField.DATOS_ORGANISMO]: '',
  [FormField.DATOS_ORGANISMO_ORIGEN]: null,
  [FormField.DATOS_NUMERO_EXPEDIENTE_ORIGEN]: '',
  [FormField.DATOS_YEAR_EXPEDIENTE_ORIGEN]: '',
  [FormField.DOCUMENTOS_ANEXOS]: [],
  [FormField.DOCUMENTOS_ANEXOS_ARCHIVO]: [],
  [FormField.DOCUMENTO_PRINCIPAL]: [
    {
      archivo: null,
      subtipo: null,
      descripcion: '',
      pendienteCompletar: false,
      hash: null,
      sign: true
    }
  ],
  [FormField.ES_CORRECCION]: false,
  [FormField.DOCUMENTO_PRINCIPAL_ARCHIVO]: { file: {} as File, hash: null },
  [FormField.EXCESO_CABIDA]: false,
  [FormField.ID_MENSAJE_CORRECCION]: '',
  [FormField.INTERVINIENTES]: [],
  [FormField.INTERVINIENTES_FROM_LEXON_VALIDATED]: true,
  [FormField.INTERVINIENTE_INFORMAR_FISCALIA]: false,
  [FormField.NIG_FULL_NUMBER]: '',
  [FormField.NIG_1]: '',
  [FormField.NIG_2]: '',
  [FormField.NIG_3]: '',
  [FormField.NIG_4]: '',
  [FormField.NIG_5]: '',
  [FormField.NIG_FORM_EXPEDIENTE]: '',
  [FormField.ORGANO_DESTINO]: null,
  [FormField.ORGANO_DESTINO_DESCRIPCION]: '',
  [FormField.ORGANO_DESTINO_ENVIAR_JUZGADO_GUARDIA]: false,
  [FormField.ORGANO_DESTINO_DE_TITULO_JUDICIAL]: null,
  [FormField.ORGANO_DESTINO_ORDEN_DESCRIPCION]: '',
  [FormField.CAUTELAR]: CautelarOpciones.NO,
  [FormField.ORGANO_ORIGEN]: null,
  [FormField.ORGANO_ORIGEN_DESCRIPCION]: '',
  [FormField.ORGANO_ORIGEN_ORDEN_DESCRIPCION]: '',
  [FormField.ORGANO_ORIGEN_ENVIAR_JUZGADO_GUARDIA]: false,
  [FormField.ORGANO_ORIGEN_TIPO_ORIGEN]: null,
  [FormField.ORGANO_ORIGEN_ORGANISMO_ORIGEN]: null,
  [FormField.ORGANO_ORIGEN_NUMERO_EXPEDIENTE]: '',
  [FormField.ORGANO_ORIGEN_YEAR_EXPEDIENTE]: '',
  [FormField.RESOLUCION]: ResolucionOpciones.NO,
  [FormField.TIPO]: null,
  [FormField.TIPO_ESCRITO]: null,
  [FormField.TIPO_RESOLUCION]: null,
  [FormField.FECHA_RESOLUCION]: null,
  [FormField.NUMERO_RESOLUCION]: '',
  [FormField.YEAR_RESOLUCION]: '',
  [FormField.RESOLUCION_BIS]: false,
  [FormField.PROCEDIMIENTO]: ProcedimientoFormInitialvalues,
  [FormField.PROCEDIMIENTO_DESCRIPCION]: '',
  [FormField.PROCEDIMIENTO_NUMERO_PIEZA]: '',
  [FormField.PROCEDIMIENTO_ORIGEN]: '',
  [FormField.PROCEDIMIENTO_ORIGEN_REFERENCIA]: '',
  [FormField.PROCEDIMIENTO_REFERENCIA]: '',
  [FormField.PROCEDIMIENTO_NUMERO_FORM]: '',
  [FormField.PROCEDIMIENTO_YEAR_FORM]: '',
  [FormField.REMITENTE_TITULAR]: getRemitenteFromLexnetCookie(),
  [FormField.TRASLADO_COPIAS]: [],
  [FormField.TRASLADO_COPIA]: null
}

export type EscritoFormClearByOrganoArguments = {
  organoDestino: OrganoDestinoFormValues | null
  organoDestinoDescription: string
  ordenDescription: string
  remitente: string
  trasladoCopias: TrasladoCopia[]
}

export const EscritoFormClearByOrganoValues = (
  arg: EscritoFormClearByOrganoArguments
): EscritosFormValues => {
  return {
    [FormField.ID]: 0,
    [FormField.DATOS_OBSERVACIONES]: '',
    [FormField.DATOS_ORIGEN_DEUDA]: '',
    [FormField.DATOS_FUNDAMENTOS_DERECHO]: '',
    [FormField.DATOS_RECLAMACION_CONSUMIDOR]: false,
    [FormField.DATOS_RECLAMACION_COMUNIDAD]: false,
    [FormField.DATOS_DEUDA_PARTIDO_JUDICIAL]: false,
    [FormField.DATOS_MASC]: true,
    [FormField.DATOS_PETICION]: '',
    [FormField.DATOS_PETICION_COMPLEMENTARIA]: '',
    [FormField.DATOS_TIPO_CUANTIA]: null,
    [FormField.DATOS_CUANTIA_RECONVENCION]: '',
    [FormField.DATOS_RECONVENCION]: 'No',
    [FormField.DATOS_URGENTE]: false,
    [FormField.DATOS_MATERIA]: null,
    [FormField.DATOS_MERCANTIL]: false,
    [FormField.DATOS_DELITO]: null,
    [FormField.DATOS_LOCALIDAD]: '',
    [FormField.DATOS_FECHA]: null,
    [FormField.DATOS_HORA]: null,
    [FormField.DATOS_MEDIDA_CAUTELAR_PREVIA]: false,
    [FormField.DATOS_MEDIDA_CAUTELAR_COETANEA]: false,
    [FormField.DATOS_CAUTELARISIMA]: false,
    [FormField.DATOS_CAUSA_CON_DETENIDO]: false,
    [FormField.DATOS_CAUSA_CON_PRESO]: false,
    [FormField.DATOS_VIOLENCIA_GENERO]: false,
    [FormField.DATOS_CUANTIA_PRINCIPAL]: '',
    [FormField.DATOS_CUANTIA_INTERESES]: '0',
    [FormField.DATOS_CUANTIA_COSTAS]: '0',
    [FormField.DATOS_CUANTIA_INTERESES_REMUNERATORIOS]: '',
    [FormField.DATOS_CUANTIA_INTERESES_DEMORA]: '',
    [FormField.DATOS_CUANTIA_COMISION_IMPAGO_RECIBOS]: '',
    [FormField.DATOS_CUANTIA_PENALIZACION_RETRASO_PAGO]: '',
    [FormField.DATOS_FECHA_ACUERDO]: null,
    [FormField.DATOS_OBJETO_RECURSO]: '',
    [FormField.DATOS_ORGANISMO]: '',
    [FormField.DATOS_ORGANISMO_ORIGEN]: null,
    [FormField.DATOS_NUMERO_EXPEDIENTE_ORIGEN]: '',
    [FormField.DATOS_YEAR_EXPEDIENTE_ORIGEN]: '',
    [FormField.DOCUMENTOS_ANEXOS]: [],
    [FormField.DOCUMENTOS_ANEXOS_ARCHIVO]: [],
    [FormField.DOCUMENTO_PRINCIPAL]: [
      {
        archivo: null,
        subtipo: null,
        descripcion: '',
        pendienteCompletar: false,
        hash: null,
        sign: true
      }
    ],
    [FormField.ES_CORRECCION]: false,
    [FormField.DOCUMENTO_PRINCIPAL_ARCHIVO]: { file: {} as File, hash: null },
    [FormField.EXCESO_CABIDA]: false,
    [FormField.ID_MENSAJE_CORRECCION]: '',
    [FormField.INTERVINIENTES]: [],
    [FormField.INTERVINIENTES_FROM_LEXON_VALIDATED]: true,
    [FormField.INTERVINIENTE_INFORMAR_FISCALIA]: false,
    [FormField.NIG_FULL_NUMBER]: '',
    [FormField.NIG_1]: '',
    [FormField.NIG_2]: '',
    [FormField.NIG_3]: '',
    [FormField.NIG_4]: '',
    [FormField.NIG_5]: '',
    [FormField.NIG_FORM_EXPEDIENTE]: '',
    [FormField.ORGANO_DESTINO]: arg.organoDestino,
    [FormField.ORGANO_DESTINO_ENVIAR_JUZGADO_GUARDIA]: false,
    [FormField.ORGANO_DESTINO_DE_TITULO_JUDICIAL]: null,
    [FormField.ORGANO_DESTINO_DESCRIPCION]: arg.organoDestinoDescription,
    [FormField.ORGANO_DESTINO_ORDEN_DESCRIPCION]: arg.ordenDescription,
    [FormField.CAUTELAR]: CautelarOpciones.NO,
    [FormField.ORGANO_ORIGEN]: null,
    [FormField.ORGANO_ORIGEN_DESCRIPCION]: arg.organoDestinoDescription,
    [FormField.ORGANO_ORIGEN_ORDEN_DESCRIPCION]: arg.ordenDescription,
    [FormField.ORGANO_ORIGEN_ENVIAR_JUZGADO_GUARDIA]: false,
    [FormField.ORGANO_ORIGEN_TIPO_ORIGEN]: null,
    [FormField.ORGANO_ORIGEN_ORGANISMO_ORIGEN]: null,
    [FormField.ORGANO_ORIGEN_NUMERO_EXPEDIENTE]: '',
    [FormField.ORGANO_ORIGEN_YEAR_EXPEDIENTE]: '',
    [FormField.RESOLUCION]: ResolucionOpciones.NO,
    [FormField.TIPO]: null,
    [FormField.TIPO_ESCRITO]: null,
    [FormField.TIPO_RESOLUCION]: null,
    [FormField.FECHA_RESOLUCION]: null,
    [FormField.NUMERO_RESOLUCION]: '',
    [FormField.YEAR_RESOLUCION]: '',
    [FormField.RESOLUCION_BIS]: false,
    [FormField.PROCEDIMIENTO]: ProcedimientoFormInitialvalues,
    [FormField.PROCEDIMIENTO_DESCRIPCION]: '',
    [FormField.PROCEDIMIENTO_NUMERO_PIEZA]: '',
    [FormField.PROCEDIMIENTO_ORIGEN]: '',
    [FormField.PROCEDIMIENTO_ORIGEN_REFERENCIA]: '',
    [FormField.PROCEDIMIENTO_REFERENCIA]: '',
    [FormField.PROCEDIMIENTO_NUMERO_FORM]: '',
    [FormField.PROCEDIMIENTO_YEAR_FORM]: '',
    [FormField.REMITENTE_TITULAR]: arg.remitente,
    [FormField.TRASLADO_COPIAS]: arg.trasladoCopias,
    [FormField.TRASLADO_COPIA]: null
  }
}
